// Generated types for SecurityScope
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { PrivateNodeReadAPI, PrivateNodeWriteAPI } from './privatenode';
import { PrivateNodeReadAPISchemaObject, PrivateNodeWriteAPISchemaObject } from './privatenode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SecurityScopeReadAPI extends PrivateNodeReadAPI {
  /** Creation timestamp (server-set) */
  created_at?: string | null;
}

export interface SecurityScopeWriteAPI extends PrivateNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SecurityScopeReadAPISchemaObject = PrivateNodeReadAPISchemaObject.extend({
  created_at: z.string().nullable().optional(),
}).passthrough();
export const SecurityScopeReadAPISchema: z.ZodType<SecurityScopeReadAPI> = SecurityScopeReadAPISchemaObject;

export const SecurityScopeWriteAPISchemaObject = PrivateNodeWriteAPISchemaObject.extend({}).passthrough();
export const SecurityScopeWriteAPISchema: z.ZodType<SecurityScopeWriteAPI> = SecurityScopeWriteAPISchemaObject;
